import { cloneDeep, isEqual } from 'lodash'

import { proxy } from '@/utils'

import { normalizePayload } from '@/components/services/sendingsCreate/utils'

import render from './render'

export default {
  name: 'TemplatesItem',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    loading: Boolean
  },

  computed: {
    applyDisabled() {
      return !this.sendingTypes.includes(this.proxy.type)
    },

    updateDisabled() {
      return this.loading || !this.proxyIsChanged
    }
  },

  methods: {
    _inputFilter(data) {
      const result = cloneDeep(data)
      result.payload = normalizePayload(result.type, result.payload)

      return result
    },

    transmitValue() {
      const proxy = this._outputFilter(this.proxy)
      if (!isEqual(proxy, this.value)) {
        this.$emit('input', proxy)
      }
    },

    applyHandler(event) {
      event.stopPropagation()
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      this.$emit('apply', this.value)
    },

    updateHandler() {
      this.$emit('update', this.proxy)
    },

    removeHandler() {
      this.$emit('remove', this.value.id)
    }
  },

  render
}
